export default __webpack_public_path__ + "static/media/nft10.01f79bc3.png";